module.exports = __webpack_public_path__ + "img/img (63).1df556b1.jpg";